import Request from './request'

const User = {
  getUserPermissions (callback) {
    Request.get('user/permissions').then(callback).catch(this.bad_answer)
  },
  getUserStatus (callback, bad_answer) {
    Request.get('user/status').then(callback).catch(bad_answer)
  },
  getUserProfile (callback, bad_answer) {
    Request.get('user/profile').then(callback).catch(bad_answer)
  },
  getProps(callback) {
    Request.get('user/props').then(callback).catch(this.bad_answer)
  },
  logoutUser (callback) {
    Request.get('user/logout').then(callback).catch(this.bad_answer)
  },
  loginUser (params, callback, bad_answer) {
    if (!params) {
      params = {}
    }
    Request.post('user/login', JSON.stringify(params)).then(callback).catch(bad_answer)
  },
  saveUser (params, callback) {
    Request.post('user/save', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateGroups (params, callback) {
    Request.post('user/update-groups', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getUsersList (callback) {
    Request.get('users').then(callback).catch(this.bad_answer)
  },
}
export default User
